import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Text, View } from "../_core/components";
import { Backdrop } from "../backdrop";
import { noop } from "../_util/noop";
import { useDefault } from "../_util/use-default";
import { injectValue } from "../_util/inject-value";
import { isCallable } from "../_util/is-callable";
import { useCatchMove } from "../_util/use-catch-move";
import { useConfig } from "../_util/use-config";
import { pxTransform } from "../_util/px-transform";
export function Popup(_a) {
    var _b = _a.position, position = _b === void 0 ? "bottom" : _b, _c = _a.defaultVisible, defaultVisible = _c === void 0 ? false : _c, visible = _a.visible, onVisibleChange = _a.onVisibleChange, _d = _a.mask, mask = _d === void 0 ? true : _d, _e = _a.maskClosable, maskClosable = _e === void 0 ? true : _e, overlay = _a.overlay, children = _a.children, _f = _a.onClose, onClose = _f === void 0 ? noop : _f, className = _a.className, _g = _a.destroyOnClose, destroyOnClose = _g === void 0 ? true : _g, zIndex = _a.zIndex, rawOffset = _a.offset, props = __rest(_a, ["position", "defaultVisible", "visible", "onVisibleChange", "mask", "maskClosable", "overlay", "children", "onClose", "className", "destroyOnClose", "zIndex", "offset"]);
    var classPrefix = useConfig().classPrefix;
    var _h = __read(useDefault(visible, defaultVisible, onVisibleChange), 2), opened = _h[0], setOpened = _h[1];
    var firstRenderedRef = useRef(opened);
    var timerRef = useRef(null);
    var _j = __read(useState(false), 2), expanded = _j[0], setExpanded = _j[1];
    var shouldRender = opened || expanded;
    var shouldEnter = opened && expanded;
    useEffect(function () {
        clearTimeout(timerRef.current);
        if (opened) {
            setTimeout(function () {
                setExpanded(true);
            }, 1);
        }
        else {
            timerRef.current = setTimeout(function () {
                setExpanded(false);
            }, 300);
        }
        return function () {
            firstRenderedRef.current = true;
        };
    }, [opened]);
    useCatchMove(opened);
    var open = function () { return setOpened(true); };
    var close = function (source, event) {
        onClose({ source: source, event: event });
        setOpened(false);
    };
    // 兼容老版本
    if (typeof overlay === "undefined") {
        console.warn("`Popup` API 变更，请通过 `overlay` 属性设置弹出层内容");
        return (React.createElement(View, __assign({ className: classNames(classPrefix + "-popup", className) }, props),
            React.createElement(Backdrop, { visible: opened, transparent: !mask, onClick: function (event) {
                    event.stopPropagation();
                    if (maskClosable) {
                        close("mask", event);
                    }
                } }),
            React.createElement(View, { className: classNames(classPrefix + "-popup__container", position, {
                    "is-shown": shouldRender,
                    "is-expanded": shouldEnter,
                }), style: typeof zIndex === "number" ? { zIndex: zIndex } : undefined }, children)));
    }
    var trigger = injectValue(children)(open);
    if (children && !isCallable(children) && !React.isValidElement(trigger)) {
        trigger = React.createElement(Text, null, trigger);
    }
    var offset = typeof rawOffset === "number" ? pxTransform(rawOffset, 750) : rawOffset;
    return (React.createElement(React.Fragment, null,
        children && !isCallable(children)
            ? React.cloneElement(trigger, { onClick: open })
            : trigger,
        React.createElement(View, __assign({ className: classNames(classPrefix + "-popup", className) }, props),
            React.createElement(Backdrop, { visible: opened, transparent: !mask, onClick: function (event) {
                    event.stopPropagation();
                    if (maskClosable) {
                        close("mask", event);
                    }
                }, style: {
                    top: position === "top" ? offset : undefined,
                    bottom: position === "bottom" ? offset : undefined,
                } }),
            shouldRender || !destroyOnClose ? (React.createElement(View, { className: classNames(classPrefix + "-popup__container", position, {
                    "is-shown": shouldRender,
                    "is-expanded": shouldEnter,
                }), style: {
                    zIndex: typeof zIndex === "number" ? zIndex : undefined,
                    top: position === "top" ? offset : undefined,
                    bottom: position === "bottom" ? offset : undefined,
                    marginTop: position === "center" ? offset : undefined,
                } }, firstRenderedRef.current || shouldRender
                ? injectValue(overlay)(function () { return close("call"); })
                : null)) : null)));
}
//# sourceMappingURL=Popup.js.map